import type { CustomerType } from '@/api/types';

export const CUSTOMER_TYPES: CustomerType[] = ['creator', 'business', 'brand', 'other'];
